module.exports = __webpack_public_path__ + "static/media/chordify.17435893.png";